(() => {
  const selector = 'h1,h2,h3,h4,h5,h6,.card__heading,.mdc-portfolio-title,.product__title';
  const originals = new WeakMap();
  const watched = new WeakSet();
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  function protect(element) {
    if (!element.isConnected || element.closest('[contenteditable="true"]')) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node, last;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim() && !node.parentElement.closest('.mdc-type-phrase,script,style')) last = node;
    }
    if (!last) return;
    const current = last.textContent;
    const previous = originals.get(last);
    const source = previous && (current === previous.source || current === previous.bound) ? previous.source : current;
    const match = source.match(/(\S+)\s+(\S+)(\s*)$/u);
    if (!match) return;
    const pair = match[1] + ' ' + match[2];
    const style = getComputedStyle(last.parentElement);
    context.font = style.font || [style.fontWeight, style.fontSize, style.fontFamily].join(' ');
    const letterSpacing = parseFloat(style.letterSpacing) || 0;
    const width = context.measureText(pair).width + letterSpacing * (pair.length - 1);
    const available = element.clientWidth - (parseFloat(getComputedStyle(element).paddingLeft) || 0) - (parseFloat(getComputedStyle(element).paddingRight) || 0);
    const bound = source.slice(0, match.index) + match[1] + '\u00a0' + match[2] + match[3];
    const next = available > 0 && width <= available ? bound : source;
    originals.set(last, { source, bound });
    if (last.textContent !== next) last.textContent = next;
  }
  const resize = new ResizeObserver(entries => entries.forEach(entry => protect(entry.target)));
  function scan(root = document) {
    const elements = root.matches?.(selector) ? [root, ...root.querySelectorAll(selector)] : [...root.querySelectorAll?.(selector) || []];
    elements.forEach(element => {
      protect(element);
      if (!watched.has(element)) { resize.observe(element); watched.add(element); }
    });
  }
  function start() {
    scan();
    document.fonts?.ready.then(() => scan());
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) scan(node);
    }))).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', event => scan(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();